import { Group } from '@/components/_common';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import { useDisclosure } from '@/hooks';
import { Button, Modal, Tooltip, Typography } from 'antd';
import { HelpCircle } from 'react-feather';
import ImportHelpJSON from './ImportHelpJSON';

const { Title, Paragraph, Text } = Typography;

export default function ImportHelpModal() {
  const [modalOpened, modalAction] = useDisclosure();

  return (
    <>
      <Tooltip title="Saiba mais" placement="right">
        <HelpCircle
          size={18}
          style={{ cursor: 'pointer' }}
          onClick={modalAction.open}
        />
      </Tooltip>

      <Modal
        open={modalOpened}
        onCancel={modalAction.close}
        width={800}
        footer={
          <SpaceForButton justifyContent="flex-end">
            <Button block onClick={modalAction.close}>
              Fechar
            </Button>
          </SpaceForButton>
        }
      >
        <Group gap={10} align="center">
          <HelpCircle size={24} color="orange" />

          <Title level={5} style={{ margin: 0 }}>
            Informações sobre a Importação do Orçamento
          </Title>
        </Group>

        <Paragraph style={{ marginTop: 16 }}>
          Nesta tela, você pode importar orçamentos em vários formatos para
          facilitar o gerenciamento financeiro da sua oficina. Os formatos
          suportados incluem Soma, Cilia, AudatexWeb, I360, Localiza e JSON.
        </Paragraph>

        <Paragraph>
          Abaixo, você encontrará um guia rápido sobre como realizar a
          importação de forma correta e eficiente.
        </Paragraph>

        <Text style={{ lineHeight: 1, fontWeight: 600 }}>Como utilizar:</Text>

        <ImportHelpJSON />
      </Modal>
    </>
  );
}
